import React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import { Link as RouterLink } from 'react-router-dom';
import UserName from '../user/UserName';
import { stringAvatar } from '../../utils/stringToColor';
import ThemeMenuItem from './ThemeMenuItem';
import { ENDPOINTS } from '../../constants';
import msalLogout from 'src/pages/core/authentication/LogoutMsal';

export default function AccountMenu({ setTheme, isDark, userData }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let email = userData?.me?.email;

  // handler for msal logout
  const handleLogout = () => {
    msalLogout();
  };

  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title='Account settings'>
          <IconButton
            onClick={handleClick}
            size='small'
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar
              {...stringAvatar(email ? email : '?')}
              sx={{ width: 32, height: 32 }}
            />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id='account-menu'
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        sx={{
          color: isDark ? 'white' : '#000000',
          '& .MuiMenu-root': {
            color: isDark ? 'white' : '#000000',
            backgroundColor: isDark ? '#424242' : '#FFFFFF'
          },
          '& .MuiPaper-root': {
            color: isDark ? 'white' : '#000000',
            backgroundColor: isDark ? '#424242' : '#FFFFFF'
          },
          '& .MuiMenu-list': {
            color: isDark ? 'white' : '#000000',
            backgroundColor: isDark ? '#424242' : '#FFFFFF'
          }
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: isDark ? '#424242' : '#FFFFFF',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0
            }
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem>
          <UserName email={email} />
        </MenuItem>
        <Divider />
        <ThemeMenuItem setTheme={setTheme} isDark={isDark} />
        <Divider />
        <MenuItem component={RouterLink} to={ENDPOINTS.profileSettingsUrl}>
          <Avatar sx={{ color: isDark ? 'white' : '#000000' }} /> Profile
        </MenuItem>
        <Divider />
        <MenuItem component={RouterLink} to={ENDPOINTS.settingsUrl}>
          <ListItemIcon>
            <Settings
              fontSize='small'
              sx={{ color: isDark ? 'white' : '#000000' }}
            />
          </ListItemIcon>
          Settings
        </MenuItem>
        <MenuItem
          // component={RouterLink} to={ENDPOINTS.logoutUrl}
          onClick={handleLogout}
        >
          <ListItemIcon>
            <Logout
              fontSize='small'
              sx={{ color: isDark ? 'white' : '#000000' }}
            />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
